{
  "campaigns": {
    "TESTING_DUMMY": {
      "dummyUsers": ["user3"],
      "targetCampaign": "TESTING",
      "activeUsers": ["user4"]
    }
  }
}
